import { ChangeDetectionStrategy, Component, inject, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModal, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { NotificationComponent } from '../notification/notification.component';
import { urls } from '../../constants/url';
import { LoginService } from '../../services';
import { TranslocoModule } from '@jsverse/transloco';
import { LanguageService } from '@moawen-workspace/shared';

interface menuInterface {
  name: string,
  icon: string,
  url: string,
  translateKey: string
}

@Component({
  selector: 'agency-core-agency-header',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslocoModule],
  templateUrl: './agency-header.component.html',
  styleUrl: './agency-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class AgencyHeaderComponent {
  private modalService = inject(NgbModal);
  private offcanvasService = inject(NgbOffcanvas);
  private languageService = inject(LanguageService);
  isRtl = this.languageService.isRtl;
  agencyName: any;
  menuList: menuInterface[] = [
    { name: 'Dashboard', icon: 'assets/images/agency-menu/dashboard.svg', url: urls.dashboard, translateKey: 'dashboard' },
    { name: 'Workers', icon: 'assets/images/agency-menu/workers.svg', url: urls.workers, translateKey: 'workers' },
    { name: 'Application', icon: 'assets/images/agency-menu/application.svg', url: urls.applications, translateKey: 'application' },
    { name: 'Track Onboarding', icon: 'assets/images/agency-menu/track.svg', url: urls.trackOnboarding, translateKey: 'trackOnboarding' },
    { name: 'Financial', icon: 'assets/images/agency-menu/financial.svg', url: urls.financial, translateKey: 'financial' },
    // { name: 'Agency Report', icon: 'assets/images/agency-menu/report.svg', url: urls.agencyReport, translateKey: 'agencyReport' },
    { name: 'Services', icon: 'assets/images/agency-menu/services.svg', url: urls.agencyServices, translateKey: 'agencyServices' },
    { name: 'Agency Reviews & Rating', icon: 'assets/images/agency-menu/report.svg', url: urls.agencyReviewRating, translateKey: 'agencyReviewsRating' },
    { name: 'Agency Profile', icon: 'assets/images/agency-menu/ag-profile.svg', url: urls.agencyProfile, translateKey: 'agencyProfile' },
    { name: 'Contact and Support', icon: 'assets/images/agency-menu/contact.svg', url: urls.contactSupport, translateKey: 'contactSupport' },
    { name: 'FAQs', icon: 'assets/images/agency-menu/faq.svg', url: urls.faqs, translateKey: 'faqs' },
  ]

  constructor(private cdr: ChangeDetectorRef) {
    const lang = localStorage.getItem('lang');
    this.agencyName = lang === 'en' ? localStorage.getItem('agency_name_en') : localStorage.getItem('agency_name_ar');

  }

  openEnd(content: TemplateRef<any>) {
    if (this.isRtl()) {
      this.offcanvasService.open(content, { position: 'end' });
    } else {
      this.offcanvasService.open(content, { position: 'start' });
    }
  }

  openNotification() {
    this.modalService.open(NotificationComponent, { size: 'md', centered: true });
  }
}
